module.exports = __webpack_public_path__ + "static/media/see_where_we_are.07e9655f.jpg";